module.exports = __webpack_public_path__ + "img/download.2a7860b6.svg";